import { Component, input } from '@angular/core';

@Component({
  selector: 'customer-app-dynamic-spacer',
  templateUrl: './dynamic-spacer.component.html',
  styleUrls: ['./dynamic-spacer.component.scss'],
  standalone: false
})
export class DynamicSpacerComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly data = input<any>(undefined);
}
